var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StreamerStatus } from "../../interlucent/streamerStatus";
import { useRef, useState } from "react";
import "../../styles/Joystick.css";
import { useAppState } from "../context/AppStateContext";
import { SceneStates } from "../../datas/constants";
export default function Joystick(_a) {
    var startMoveFunction = _a.startMoveFunction, endMoveFunction = _a.endMoveFunction, isMobile = _a.isMobile, isLandscape = _a.isLandscape, streamerStatus = _a.streamerStatus;
    var sceneState = useAppState().sceneState;
    var svgRef = useRef(null);
    var _b = useState(null), activeDir = _b[0], setActiveDir = _b[1];
    var visible = isMobile &&
        streamerStatus === StreamerStatus.Connected &&
        [SceneStates.CUVE_ALCOOL, SceneStates.CUVE_REACTEUR].includes(sceneState);
    if (!visible)
        return null;
    var detectDirection = function (x, y) {
        var _a;
        var rect = (_a = svgRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!rect)
            return null;
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var dx = x - cx;
        var dy = y - cy;
        if (Math.abs(dx) > Math.abs(dy))
            return dx > 0 ? "Droite" : "Gauche";
        return dy > 0 ? "Bas" : "Haut";
    };
    var updateDirection = function (dir) {
        if (!dir || dir === activeDir)
            return;
        if (activeDir) {
            console.log("Stop:", activeDir);
            endMoveFunction(activeDir);
        }
        console.log("Start:", dir);
        startMoveFunction(dir);
        setActiveDir(dir);
    };
    var handleTouchStart = function (e) {
        e.preventDefault();
        var touch = e.touches[0];
        var dir = detectDirection(touch.clientX, touch.clientY);
        updateDirection(dir);
    };
    var handleTouchMove = function (e) {
        e.preventDefault();
        var touch = e.touches[0];
        var dir = detectDirection(touch.clientX, touch.clientY);
        updateDirection(dir);
    };
    var handleTouchEnd = function (e) {
        e.preventDefault();
        if (activeDir) {
            console.log("Stop:", activeDir);
            endMoveFunction(activeDir);
            setActiveDir(null);
        }
    };
    return (_jsx("div", __assign({ className: "joystick ".concat(isLandscape ? "landscape" : "portrait"), onContextMenu: function (e) { return e.preventDefault(); } }, { children: _jsxs("svg", __assign({ ref: svgRef, viewBox: "0 0 120 120", width: "120", height: "120", onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd }, { children: [_jsx("circle", { cx: "60", cy: "60", r: "58", fill: "#222", stroke: "#666", strokeWidth: "2" }), _jsx("polygon", { points: "60,20 70,35 50,35", fill: "rgba(255,255,255,0.15)" }), _jsx("polygon", { points: "50,85 70,85 60,100", fill: "rgba(255,255,255,0.15)" }), _jsx("polygon", { points: "20,60 35,50 35,70", fill: "rgba(255,255,255,0.15)" }), _jsx("polygon", { points: "100,60 85,50 85,70", fill: "rgba(255,255,255,0.15)" }), _jsx("circle", { cx: "60", cy: "60", r: "14", fill: "#444" }), _jsx("circle", { cx: "60", cy: "60", r: "9", fill: "#61c3ef", opacity: "0.3" })] })) })));
}
